module.exports = __webpack_public_path__ + "static/sydney-harbour-bridge-6b683688d8dc6082760bc94c108a8c3b.jpg";